import { getDeviceDetails } from '../device';
import { getActiveLocks } from './active_locks';

// Constants

export const BOTTOM_BAR_CHECK_DELAY = 300;
export const isIOS = getDeviceDetails().isIOS;

// Touch event utilities

let initialClientY = -1;

export const getInitialClientY = (): number => {
    return initialClientY;
};

export const setInitialClientY = (clientY: number): void => {
    initialClientY = clientY;
};

const shouldAllowTouchMove = (target: EventTarget | null): boolean => {
    if (!target) return false;

    // Allow touch move if the target element is allowed to move (targetElement)
    return getActiveLocks().some((lock) => lock.options.allowTouchMove?.(target) === true);
};

export const handleTouchStart = (event: TouchEvent): void => {
    // Touch is on the target element, and there is no multi-touch gesture
    if (event.targetTouches.length === 1) {
        initialClientY = event.targetTouches[0].clientY;
    }
};

export const createTouchMoveHandler = (targetElement: HTMLElement) => {
    return (event: TouchEvent): boolean => {
        if (event.targetTouches.length !== 1 || shouldAllowTouchMove(event.target)) {
            return false;
        }

        const clientY = event.targetTouches[0].clientY - initialClientY;

        // Prevent scrolling up when at top
        if (targetElement.scrollTop === 0 && clientY > 0 && event.cancelable) {
            return preventDefault(event);
        }

        // Prevent scrolling down when at bottom
        const isFullyScrolled = targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight;
        if (isFullyScrolled && clientY < 0 && event.cancelable) {
            return preventDefault(event);
        }

        event.stopPropagation();

        return true;
    };
};

export const preventDocumentTouchMove = (event: TouchEvent): boolean => {
    if (!event.cancelable) return true;
    if (shouldAllowTouchMove(event.target)) return true;
    if (event.touches.length > 1) return true; // Multi-touch gesture

    return preventDefault(event);
};

const preventDefault = (event: TouchEvent): boolean => {
    if (event.cancelable && event.preventDefault) {
        event.preventDefault();
    }
    return false;
};
